import { gql } from "@apollo/client"
export const getAllParentsQuery = gql`
    query getParents(
        $searchString:String,
        $pageNumber:Float,
        $pageLimit:Float
    ) {
        getAllParents(
            searchString:$searchString,
            pageNumber:$pageNumber,
            pageLimit:$pageLimit
        ) {
            items {
                id
                taskPoint
                assessmentPoint
                quizPoint
                conversionPoints
                conversionMoney
                name
                hasNotification
                notificationTime
                mobileNumber
                spouseName
                familyName
                isRealMoneyUser
                photoURL
                    error{
                    statusCode
                    message
                    }
            }
            pagination{
                pageNumber
                pageLimit
                totalCount
            }
            }
        }
`

export const deleteParentMutation = gql`
    mutation deleteParent($id:Int!) {
        deleteParent(id: $id) {
        id
        status
        error {
            message
        }
        }
    }
`

export const createParentMutation = gql `
    mutation createParent($data:parentInput) {
        createParent(data: $data) {
        id
        status
        error {
            message
        }
        }
    }
`


export const updateParentMutation = gql `
    mutation updateParent($id:Int!, $data:parentInput) {
        updateParent(id:$id, data:  $data) {
        id
        status
        error {
            message
        }
        }
    }
`

